import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import StablishmentRepository from "../../repositories/StablishmentRepository";

interface _Props {
    stablishmentRepository: StablishmentRepository;
}

@injectable()
export default class DeleteScheduleUseCase {
    private stablishmentRepository: StablishmentRepository;
    
    constructor(props: _Props) {
        this.stablishmentRepository = props.stablishmentRepository;
    }
    
    public call = async (id: string): Promise<Either<ErrorEntity, void>> => {
        return await this.stablishmentRepository.deleteSchedule(id);
    }
}

export const DeleteScheduleUseCaseName = "DeleteScheduleUseCase";